module.exports = __webpack_public_path__ + "static/media/YF24_0.70e1bfab.jpg";